// extracted by mini-css-extract-plugin
module.exports = {"news-item-box":"L","newsItemBox":"L","img-box":"M","imgBox":"M","img-mask-box":"N","imgMaskBox":"N"};